/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_ModeInputs */

const en_case_payment_mode = /** @type {(inputs: Case_Payment_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment method`)
};

const pt_br2_case_payment_mode = /** @type {(inputs: Case_Payment_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma de pagamento`)
};

/**
* | output |
* | --- |
* | "Payment method" |
*
* @param {Case_Payment_ModeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_mode = /** @type {((inputs?: Case_Payment_ModeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_ModeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_mode(inputs)
	return pt_br2_case_payment_mode(inputs)
});